var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87999 1.29001L5.99999 5.17001L2.11999 1.29001C2.02741 1.19742 1.9175 1.12399 1.79653 1.07388C1.67557 1.02378 1.54592 0.997986 1.41499 0.997986C1.28406 0.997986 1.15441 1.02378 1.03345 1.07388C0.912482 1.12399 0.802571 1.19742 0.70999 1.29001C0.617408 1.38259 0.543968 1.4925 0.493863 1.61346C0.443758 1.73443 0.417969 1.86408 0.417969 1.99501C0.417969 2.12594 0.443758 2.25559 0.493863 2.37655C0.543968 2.49751 0.617408 2.60742 0.70999 2.70001L5.29999 7.29001C5.68999 7.68001 6.31999 7.68001 6.70999 7.29001L11.3 2.70001C11.3927 2.60749 11.4662 2.4976 11.5164 2.37663C11.5666 2.25566 11.5924 2.12598 11.5924 1.99501C11.5924 1.86404 11.5666 1.73436 11.5164 1.61338C11.4662 1.49241 11.3927 1.38252 11.3 1.29001C10.91 0.910007 10.27 0.900007 9.87999 1.29001Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.2d3d12ff50cf83e9a0222cf0db2c3bf7.svg";
export { ForwardRef as ReactComponent };